import type { Me } from "./api.js";

export interface AuthTutorIdentity {
  tutorProfileId: string | null;
  providerId: number | null;
  displayName: string | null;
}

/**
 * Extend the hand-written `/auth/me` shape without forcing every existing test
 * fixture to grow the new presentation-only field at once. Production bootstrap
 * always returns it; an omitted field means an older/mocked response and callers
 * fall back to the existing scheduling endpoint.
 */
declare module "./api.js" {
  interface Me {
    tutorIdentity?: AuthTutorIdentity | null;
  }
}

let remembered: AuthTutorIdentity | undefined;

/** Seed before React publishes `me`, so child pages can reuse it immediately. */
export function rememberAuthTutorIdentity(me: Me | null): void {
  if (me === null || me.tutorIdentity === undefined) {
    remembered = undefined;
    return;
  }
  remembered = me.tutorIdentity ?? {
    tutorProfileId: null,
    providerId: null,
    displayName: null,
  };
}

export function rememberedAuthTutorIdentity(): AuthTutorIdentity | undefined {
  return remembered;
}
